import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DashboardResponseDto, DashboardService } from 'src/app/backend';
import { BaseComponent } from '../../core/components/base/base.component';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent extends BaseComponent implements OnInit {
  stats: any | null = null;
  isLoading = false;
  dashboardData: DashboardResponseDto | undefined;

  constructor(
    private dashboardService: DashboardService,
    private t: TranslateService,
    authService: AuthService,
    msgService: NzMessageService
  ) {
    super(authService, t, msgService);
  }

  ngOnInit() {
    this.isLoading = true;
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    this.dashboardService
      .apiDashboardGet()
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.dashboardData = res;
            });
   }
}
